import { LessonProblem, StudentResults } from '@yandex-int/k-common/typings';
import { Paginator } from 'platform-components';
import { PAGINATOR_BUTTON_VIEW, PAGINATOR_THEME } from 'platform-components/constants';
import { Page } from 'platform-components/src/components/paginator/types';
import React from 'react';

import { PROBLEM_DISPLAY_STATUS } from 'common.components/student-lesson-stat/typings';
import { getProblemDisplayStatus } from 'common.components/student-lesson-stat/utils';

import './lesson-content__paginator.scss';

interface Props {
    onProblemItemClick: (problemId: number | null) => void;
    selectedProblemId: number | null;
    problems: Array<LessonProblem>;
    studentResults: StudentResults | null;
}

const PROBLEM_STATUS_TO_PAGINATOR_BUTTON_VIEW = {
    [PROBLEM_DISPLAY_STATUS.CORRECT]: PAGINATOR_BUTTON_VIEW.GREEN,
    [PROBLEM_DISPLAY_STATUS.INCORRECT]: PAGINATOR_BUTTON_VIEW.RED,
} as Record<PROBLEM_DISPLAY_STATUS, PAGINATOR_BUTTON_VIEW>;

export const LessonContentProblemsPaginator = (props: Props) => {
    const { problems, selectedProblemId, onProblemItemClick, studentResults } = props;

    if (problems.length < 2) {
        return null;
    }

    const pages: Array<Page> = problems.map((problem, index) => {
        const studentProblemResult = studentResults?.problems[problem.id] || null;
        const status = getProblemDisplayStatus(problem, studentProblemResult);

        return {
            number: index,
            selected: problem.id === selectedProblemId,
            onClick: () => onProblemItemClick(problem.id),
            disabled: false,
            text: (index + 1).toString(),
            view: PROBLEM_STATUS_TO_PAGINATOR_BUTTON_VIEW[status] || PAGINATOR_BUTTON_VIEW.DEFAULT,
        };
    });

    return (
        <div className="lesson-content__paginator-wrapper">
            <Paginator
                key={selectedProblemId || undefined}
                mix="lesson-content__paginator"
                pages={pages}
                theme={PAGINATOR_THEME.WHITE}
            />
        </div>
    );
};
